/*
  Bloc Selleasy « Composez votre look » (fiche produit).
  Le style est géré dans Selleasy (CSS personnalisé). La campagne Selleasy est réglée sur
  « Aucune réduction » : sinon l'appli pose un code promo au panier à chaque ajout (+1 s,
  et le code client est remplacé). La remise réelle vient des réductions automatiques
  Shopify ; ce script affiche l'offre correspondante :
  - paliers « 3 achetés = -30% en plus » (atteint) / « 2 = -20% » (non atteint) ;
  - prix des cartes et total remisés selon le palier atteint ;
  - prix barrés = prix de base avant toute promo (compare_at_price) ;
  - nom produit réduit au type + nom du modèle (« Kimono long … | Haruka » → « Kimono Haruka ») ;
  - bouton « Je valide mon look à -20% » (sans palier atteint : texte Selleasy seul).
  Carrousel Selleasy « Vous pourriez aussi aimer » du tiroir panier (toutes les pages) :
  même réduction du nom (« Peignoir kimono … | Tsukine » → « Peignoir Tsukine »).
  Selleasy réaffiche le bloc à chaque sélection : on réapplique via un observer.
*/
(() => {
  // À aligner sur les réductions automatiques Shopify (PROMO RENTRÉE) à chaque changement de promo.
  const TIERS = [
    { quantity: 2, discount: 10 },
    { quantity: 3, discount: 20 },
  ];

  const products = new Map();

  const formatMoney = (cents) => `${(cents / 100).toFixed(2).replace('.', ',')}€`;

  const loadProduct = (handle) => {
    if (!products.has(handle)) {
      products.set(
        handle,
        fetch(`/products/${handle}.js`)
          .then((response) => (response.ok ? response.json() : null))
          .catch(() => null)
      );
    }
    return products.get(handle);
  };

  const setText = (element, text) => {
    if (element && element.textContent !== text) element.textContent = text;
  };

  // Garde le texte d'origine Selleasy pour pouvoir le relire après nos modifications.
  const sourceText = (element) => {
    if (element.dataset.mkSource === undefined || element.textContent !== element.dataset.mkText) {
      element.dataset.mkSource = element.textContent.trim();
    }
    return element.dataset.mkSource;
  };

  const deriveText = (element, text) => {
    if (!element) return;
    setText(element, text);
    element.dataset.mkText = text;
  };

  const isChecked = (card) => {
    const checkbox = card.querySelector('input.lb-card-checkbox');
    return !checkbox || checkbox.checked;
  };

  const reachedTier = (count) =>
    TIERS.filter((tier) => count >= tier.quantity).sort((a, b) => b.quantity - a.quantity)[0];

  const renderTiers = (widget, tier) => {
    const header = widget.querySelector('.lb-bundle-title-cont');
    if (!header) return;
    let list = header.querySelector('.lb-bundle-discountText');
    if (!list) {
      list = document.createElement('div');
      list.className = 'lb-bundle-discountText lb-discount-tier';
      list.style.display = 'flex';
      header.append(list);
    }

    const ordered = [...TIERS].sort((a, b) => (b === tier) - (a === tier) || a.quantity - b.quantity);
    const html = ordered
      .map((item) =>
        item === tier
          ? `<div class="lb-bundle-discountText-pills lb-selected-tier">${item.quantity} achetés = -${item.discount}% en plus</div>`
          : `<div class="lb-bundle-discountText-pills">${item.quantity} = -${item.discount}%</div>`
      )
      .join('');
    if (list.dataset.mkHtml !== html) {
      list.innerHTML = html;
      list.dataset.mkHtml = html;
    }
  };

  const updateButton = (widget, tier) => {
    const button = widget.querySelector('.lb-bundle-cta .lb-button');
    if (!button) return;
    const text = sourceText(button).replace(/ à -\d+%$/, '');
    deriveText(button, tier ? `${text} à -${tier.discount}%` : text);
  };

  const shortenTitles = (widget) => {
    widget.querySelectorAll('.lb-card-title').forEach((title) => {
      const text = sourceText(title);
      deriveText(title, text.includes('|') ? `${text.split(/\s+/)[0]} ${text.split('|').pop().trim()}` : text);
      // Nom court affiché, nom complet annoncé : deux modèles homonymes (Emiko homme / femme)
      // ne doivent pas donner deux liens de même nom vers des pages différentes.
      if (title.getAttribute('aria-label') !== text) title.setAttribute('aria-label', text);
    });
  };

  // Selleasy pose role="listitem" sur ses cartes sans role="list" sur leur conteneur.
  const fixListRoles = () => {
    document.querySelectorAll('[role="listitem"].lb-product-card').forEach((card) => {
      const parent = card.parentElement;
      if (parent && !parent.hasAttribute('role')) parent.setAttribute('role', 'list');
    });
  };

  const updatePrices = async (widget, tier) => {
    const cards = [...widget.querySelectorAll('.lb-product-card[lb-product-handle]')];
    const rate = tier ? 1 - tier.discount / 100 : 1;
    let base = 0;
    let sale = 0;
    let complete = true;

    for (const card of cards) {
      const product = await loadProduct(card.getAttribute('lb-product-handle'));
      const variantId = Number(card.getAttribute('lb-variant-id'));
      const variant = product && product.variants.find((item) => item.id === variantId);
      if (!variant) {
        complete = false;
        continue;
      }

      // Arrondi par article, comme la remise Shopify au panier.
      const cardBase = Math.max(variant.compare_at_price || 0, variant.price);
      const cardSale = Math.round(variant.price * rate);
      setText(card.querySelector('.lb-price-compare-price'), formatMoney(cardBase));
      setText(card.querySelector('.lb-price-sale-price'), formatMoney(cardSale));

      if (isChecked(card)) {
        base += cardBase;
        sale += cardSale;
      }
    }

    if (complete && base > 0) {
      setText(widget.querySelector('.lb-bundle-cta .lb-price-compare-price'), formatMoney(base));
      setText(widget.querySelector('.lb-bundle-cta .lb-price-sale-price'), formatMoney(sale));
    }
  };

  let scheduled = false;
  const refresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      document.querySelectorAll('.lb-addon-cont').forEach(shortenTitles);
      fixListRoles();
      document.querySelectorAll('.lb-bundle-cont').forEach((widget) => {
        const cards = [...widget.querySelectorAll('.lb-product-card[lb-product-handle]')];
        const tier = reachedTier(cards.filter(isChecked).length);
        renderTiers(widget, tier);
        updateButton(widget, tier);
        shortenTitles(widget);
        updatePrices(widget, tier);
      });
    });
  };

  new MutationObserver(refresh).observe(document.body, {
    childList: true,
    subtree: true,
    characterData: true,
    attributes: true,
    attributeFilter: ['class', 'lb-variant-id', 'lb-selected'],
  });
  document.addEventListener('change', refresh);
  refresh();
})();
